<template>
  <div
    class="relative inline-flex flex-col make-select"
    :class="{
      'has-errors': hasErrors
    }"
  >
    <slot
      v-if="!withoutLabel"
      name="label"
    >
      <mia-feature-label
        :for="uniqueId"
        text="Hersteller"
      />
    </slot>

    <slot
      :for="uniqueId"
      :makes="selectableMakes"
    >
      <mia-multi-select
        v-bind="attrs"
        v-on="listeners"
      />
    </slot>

    <mia-fade-transition>
      <small
        v-if="errors.length > 0"
        class="absolute top-0 block leading-3 text-red-600 mt-17"
        v-text="errors[0]"
      />
    </mia-fade-transition>
  </div>
</template>

<script>
import { getMakes } from '@/api/cars'
import FeatureLabel from '@/components/cars/edit/FeatureLabel.vue'

export default {
  name: 'MiaMakeSelect',

  components: {
    'mia-feature-label': FeatureLabel
  },

  props: {
    value: {
      type: String,
      required: true
    },

    makes: {
      type: Array,
      default() {
        return []
      }
    },

    errors: {
      type: Array,
      default() {
        return []
      }
    },

    withoutLabel: {
      type: Boolean,
      default: false
    },

    only: {
      type: Array,
      default() {
        return []
      }
    },

    formatLabel: {
      type: Function,
      default(label) {
        return label
      }
    }
  },

  data() {
    return {
      fetchedMakes: []
    }
  },

  computed: {
    attrs() {
      return {
        placeholder: 'Marke auswählen',
        ...this.$attrs,
        'custom-label': this.getLabel,
        flatten: true,
        id: this.uniqueId,
        options: this.selectableMakes,
        'track-by': 'name',
        value: this.value
      }
    },

    listeners() {
      return {
        ...this.$listeners,
        input: event => this.$emit('input', event || '')
      }
    },

    hasCustomMakes() {
      return this.makes.length > 0
    },

    selectableMakes() {
      const makes = this.hasCustomMakes ? this.makes : this.fetchedMakes

      if (this.only.length > 0) {
        return makes.filter(({ name }) => this.only.includes(name))
      }

      return makes
    },

    uniqueId() {
      // eslint-disable-next-line no-underscore-dangle
      return `make-${this._uid}`
    },

    hasErrors() {
      return this.errors.length > 0
    }
  },

  async created() {
    if (this.hasCustomMakes) return

    this.fetchedMakes = await getMakes()
  },

  methods: {
    getLabel(id) {
      if (this.selectableMakes.length === 0) return ''

      const label = this.selectableMakes.find(({ name }) => name === id).description

      if (this.formatLabel && typeof this.formatLabel === 'function') {
        return this.formatLabel(label, id)
      }

      return label
    }
  }
}
</script>

<style lang="scss" scoped>
.make-select.has-errors ::v-deep .multiselect {
  @apply shadow-outline-error;
  @apply rounded;
}
</style>
